module.exports = __webpack_public_path__ + "media/assets/images/lib/content-tools/ce-drop-above-e9df5e7c58a5584a9c4c42bb5f1504a4.png";